import request from '@/shared/api/request';

import type { BucketDir } from '../types';

export const getBucketDir = ({
  name,
  path,
}: {
  name: string;
  path: string;
}): Promise<{ children: BucketDir[] }> =>
  request({
    url: `/buckets/${name}/objects/dirs?path=${path}`,
  });
